import { render } from "./SelectSfxy.vue?vue&type=template&id=0571c886"
import script from "./SelectSfxy.vue?vue&type=script&lang=js"
export * from "./SelectSfxy.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__